module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point01/th_04-56d16c5a766ec81e8e3f89eaadc92217.jpg";